/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./task-table.vue?vue&type=template&id=45f70ac1&"
import script from "./task-table.vue?vue&type=script&lang=js&"
export * from "./task-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports